module.exports = __webpack_public_path__ + "static/img/b201.af19b8c4.png";